export const SET_FETCHING_FILE_DATA_IMPORT = 'SET_FETCHING_FILE_DATA_IMPORT';
export const SET_FILE_DATA_IMPORT_ERROR = 'SET_FILE_DATA_IMPORT_ERROR';
export const SET_FETCHING_PREVIOUS_IMPORTS = 'SET_FETCHING_PREVIOUS_IMPORTS';
export const SET_PREVIOUS_IMPORTS = 'SET_PREVIOUS_IMPORTS';
export const SET_PREVIOUS_IMPORTS_ERROR = 'SET_PREVIOUS_IMPORTS_ERROR';
export const SET_FETCHING_CUSTOM_FIELDS = 'SET_FETCHING_CUSTOM_FIELDS';
export const SET_CUSTOM_FIELDS_FOR_IMPORT = 'SET_CUSTOM_FIELDS_FOR_IMPORT';
export const SET_CUSTOM_FIELDS_FOR_IMPORT_ERROR = 'SET_CUSTOM_FIELDS_FOR_IMPORT_ERROR';